<table-view
  [columnTitles]="columnTitles"
  [rows]="rows"
></table-view>